export const ACTIONS = {
	RESET: 'RESET_REDUX',
};
